// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wallet-connection-error-banner[data-v-59388644]{align-items:center;box-sizing:border-box;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100vw;z-index:510}.wallet-connection-error-banner div[data-v-59388644]{align-items:center;display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
